import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import RechargeAction from './RechargeAction.vue'

Vue.use(CreateAPI)

Vue.createAPI(RechargeAction, true)

let instance = null

export default {
  show(params) {
    instance = RechargeAction.$create({
      $props: {}
    }).show(params)
  },
  hide() {
    if (instance) {
      instance.hide()
    }
  }
}
